<template>
  <div class="per_object">
    <router-link to="/">返回</router-link>
    <h2 class="blue_title">个人征信异议申请须知</h2>
    <p class="content-text-indent">根据《金融信用信息基础数据库个人征信异议处理业务规程》，个人认为信用报告中的信息存在错误、遗漏的，可以亲自或委托代理人向征信中心、各地征信分中心提出异议申请。</p>
    <span class="blue_span">一、个人异议申请流程：</span>
    <div>
      <p class="content-text-indent">填表→微信预约→出示预约信息→提交材料→审核确认受理→送达异议回复函（见附件3）；异议不受理的，予以退回并告知不予接收的原因。</p>
    </div>
    <span class="blue_span">二、本人申请个人征信异议提交材料顺序如下：（统一用A4纸规格）</span>
    <div>
      <p class="content-text-indent">1、填写《个人征信异议申请表》（见附件1）；</p>
      <p class="content-text-indent">2、本人有效身份证件原件及复印件；</p>
      <p class="content-text-indent">3、申请法院案件异议的，需出示法院“结案证明”或相关证明材料；</p>
      <p class="content-text-indent">4、出示本人异议申请日当天的个人信用报告（申请法院异议的出示本人简易版个人信用报告）；</p>
      <p class="content-text-indent">5、如委托他人代理申请个人异议须填写《个人征信异议授权委托书》（见附2）；</p>
      <p class="content-text-indent">6、授权委托办理个人征信异议须提交公证处证明原件；</p>
      <p class="content-text-indent">7、代理人有效身份证件原件及复印件。</p>
    </div>
    <span class="red_span">特别提示：</span>
    <div>
      <p class="content-text-indent">1、复印件中的文字及图案要求清晰不能有遮挡（包括公章的遮挡）；</p>
      <p class="content-text-indent">2、有效身份证件包括：中国公民的居民身份证，军人的军官证、士兵证，港澳台人士的通行证，外籍人士的护照。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PerObject.vue'
}
</script>

<style scoped>
.per_object {
  padding: 20px;
}

.blue_title {
  text-align: center;
  font-size: 20px;
  font-weight: normal;
  color: #3b88d6;
}

.blue_span {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  color: #3b88d6;
}

.red_span {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  color: #f00;
}

.content-text-indent {
  text-indent: 2em;
  font-size: 12px;
  margin: 0;
  color: #999;
  line-height: 24px;
}

</style>
